
import useViewport from '../../hooks/useViewport';
import Lang from '../../layouts/Lang';
import { useContext } from 'react';
import { LangContext } from '../../context/LangContext';

import "./style.css"

function Error() {
    const { isDesktop } = useViewport();
    const { language } = useContext(LangContext);
    return (
        <div className='page page_error'>
            <Lang />
            <img className="img" src={`${process.env.REACT_APP_API_URL}/files/images/${isDesktop ? '' : '_'}page_error_${language === 'fr' ? 'VF' : 'VA'}.webp`} alt="" />
        </div>
    )
}

export default Error;